import React, { FunctionComponent } from "react";

export const ErrorText: FunctionComponent = ( props : any) => {
	return <div style={{color: "red"}}>{props.children}</div>;
};
